import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

function MySubjects() {

  const token = localStorage.getItem("access");
  const { t } = useTranslation();

  const [subjects, setSubjects] = useState([]);

  const [allSubjects, setAllSubjects] = useState([]);

  const [complaints, setComplaints] = useState([]);

  const [selectedSubjects, setSelectedSubjects] = useState([]);

  const [requestType, setRequestType] = useState("ADD");

  const [reason, setReason] = useState("");

  // =====================================================
  // LOAD DATA
  // =====================================================

  useEffect(() => {

    fetchMySubjects();

    fetchAllSubjects();

    fetchComplaints();

  }, []);

  // =====================================================
  // MY SUBJECTS
  // =====================================================

  const fetchMySubjects = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/subjects/my-subjects/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setSubjects(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // ALL SUBJECTS
  // =====================================================

  const fetchAllSubjects = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/subjects/all-subjects/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setAllSubjects(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // COMPLAINT HISTORY
  // =====================================================

  const fetchComplaints = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/subjects/my-complaints/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setComplaints(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // SUBMIT COMPLAINT
  // =====================================================

  const submitComplaint = async () => {

  if (selectedSubjects.length === 0 || !reason) {

    alert("Please complete all fields.");

    return;
  }

  try {

    for (const subjectId of selectedSubjects) {

      await axios.post(
        "https://api.eduskot.com/api/subjects/submit-complaint/",
        {
          subject_id: subjectId,
          request_type: requestType,
          reason: reason,
        },
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );
    }

    alert("Complaint submitted successfully.");

    setSelectedSubjects([]);

    setReason("");

    fetchComplaints();

  } catch (err) {

    console.error(err);

    alert("Failed to submit complaint.");
  }
};

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <h1>{t("mySubjects")}</h1>

        <button
          style={styles.backBtn}
          onClick={() =>
            window.location.href =
            "/student-home"
          }
        >
          Back
        </button>

      </div>

      {/* SUBJECTS */}

      <div style={styles.card}>

        <h2 style={styles.title}>
          {t("subjectsAssignedToYou")}
        </h2>

        <div style={styles.subjectContainer}>

          {subjects.length === 0 && (
            <p>No subjects found.</p>
          )}

          {subjects.map((s)=>(

  <div
    key={s.id}
    style={styles.subjectCard}
  >

    <div style={styles.subjectName}>
      {s.subject}
    </div>

    <div style={styles.teacherText}>

      Teacher:
      {" "}

      {s.teachers.length > 0
        ? s.teachers.join(", ")
        : "Not Assigned"}

    </div>

  </div>

))}

        </div>

      </div>

      {/* COMPLAINT FORM */}

      <div style={styles.card}>

        <h2 style={styles.title}>
          {t("subjectComplaint")}
        </h2>

        <p style={styles.text}>
          {t("subjectComplaintDesc")}
        </p>

        <select
  multiple
  value={selectedSubjects}
  onChange={(e)=>{

    const values = Array.from(
      e.target.selectedOptions,
      option => option.value
    );

    setSelectedSubjects(values);
  }}
  style={{
    ...styles.input,
    minHeight:"160px"
  }}
>

  {allSubjects.map((s)=>(

    <option
      key={s.id}
      value={s.id}
    >
      {s.name}
    </option>

  ))}

</select>

        <select
          value={requestType}
          onChange={(e)=>
            setRequestType(e.target.value)
          }
          style={styles.input}
        >

          <option value="ADD">
            {t("missingSubject")}
          </option>

          <option value="REMOVE">
            {t("wrongSubject")}
          </option>

        </select>

        <textarea
          placeholder={t("explainIssue")}
          value={reason}
          onChange={(e)=>
            setReason(e.target.value)
          }
          style={styles.textarea}
        />

        <button
          style={styles.submitBtn}
          onClick={submitComplaint}
        >
          {t("submitComplaint")}
        </button>

      </div>

      {/* COMPLAINT HISTORY */}

      <div style={styles.card}>

        <h2 style={styles.title}>
          {t("complaintHistory")}
        </h2>

        <div style={styles.tableWrapper}>

          <table style={styles.table}>

            <thead>

              <tr>
                <th>{t("subject")}</th>
                <th>{t("request")}</th>
                <th>{t("status")}</th>
              </tr>

            </thead>

            <tbody>

              {complaints.length === 0 && (

                <tr>
                  <td colSpan="3">
                    No complaints yet.
                  </td>
                </tr>
              )}

              {complaints.map((c)=>(
                <tr key={c.id}>

                  <td>{c.subject}</td>

                  <td>{t(c.request_type)}</td>

                  <td
                    style={{
                      color:
                        c.status === "APPROVED"
                        ? "#16a34a"
                        : c.status === "REJECTED"
                        ? "#ef4444"
                        : "#f59e0b",
                      fontWeight:"600"
                    }}
                  >
                    {c.status}
                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}

const styles = {

  page:{
    minHeight:"100vh",
    padding: window.innerWidth < 768 ? "6px" : "17px",
    fontFamily:"Segoe UI",
    background:"linear-gradient(120deg,#e0f2fe,#f8fafc)"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom:"30px"
  },

  card:{
    background:"white",
    padding:"25px",
    borderRadius:"14px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)",
    marginBottom:"30px"
  },

  title:{
    marginBottom:"15px"
  },

  text:{
    color:"#64748b",
    marginBottom:"15px"
  },

  subjectContainer:{
    display:"flex",
    flexWrap:"wrap",
    gap:"12px"
  },

  subjectTag:{
    background:"#2563eb",
    color:"white",
    padding:"10px 16px",
    borderRadius:"20px",
    fontWeight:"600"
  },

  input:{
    width:"100%",
    padding:"12px",
    marginBottom:"15px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  textarea:{
    width:"100%",
    minHeight:"120px",
    padding:"12px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1",
    marginBottom:"15px"
  },

  submitBtn:{
    padding:"12px 20px",
    border:"none",
    borderRadius:"10px",
    background:"#7c3aed",
    color:"white",
    fontWeight:"600",
    cursor:"pointer"
  },

  backBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"8px",
    background:"#2563eb",
    color:"white",
    cursor:"pointer"
  },

  tableWrapper:{
    overflowX:"auto"
  },

  subjectCard:{
  background:"#2563eb",
  color:"white",
  padding:"14px",
  borderRadius:"14px",
  minWidth:"220px"
},

subjectName:{
  fontWeight:"700",
  marginBottom:"6px",
  fontSize:"16px"
},

teacherText:{
  fontSize:"13px",
  opacity:"0.95"
},

  table:{
    width:"100%",
    minWidth:"500px",
    borderCollapse:"collapse",
    textAlign:"center"
  }
  

};

export default MySubjects;